import styled from 'styled-components';
import * as Tabs from '@radix-ui/react-tabs';

export const TabsRoot = styled(Tabs.Root)`
  background-color: ${({ theme }) => theme.elsie.colors.inverse.surface.faint.default};
  display: flex;
  font-family: 'NunitoSans', Verdana, Arial, sans-serif;
  flex-direction: column;
  max-width: 680px;
`;

export const TabsList = styled(Tabs.List)`
  align-self: center;
  display: flex;
  width: 100%;

  & > button {
    align-items: center;
    background: none;
    border: none;
    border-bottom: ${({ theme }) => theme.elsie.borderWidth.sm} solid
      ${({ theme }) => theme.elsie.colors.inverse.border.subtle};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex: 1;
    font-family: 'NunitoSans', Verdana, Arial, sans-serif;
    justify-content: center;
    padding: 12px 0;

    &[data-state='active'] {
      background: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.default};
      border-bottom: ${({ theme }) => theme.elsie.borderWidth.md} solid
        ${({ theme }) => theme.elsie.colors.inverse.interactive.accent.default};
    }

    &:hover {
      background: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.hovered};
    }

    &:first-of-type,
    &:first-of-type[data-state='active'],
    &:first-of-type:hover {
      border-radius: ${({ theme }) => `${theme.elsie.borderRadius.md} 0 0 0`};
    }
    &:last-of-type,
    &:last-of-type[data-state='active'],
    &:last-of-type:hover {
      border-radius: ${({ theme }) => `0 ${theme.elsie.borderRadius.md} 0 0`};
    }
  }
`;

export const TabName = styled.span`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.subtle};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
`;
